module.exports = __webpack_public_path__ + "static/media/mBenz.071789ab.png";